import React from "react";
import StudentNotificationSection from "../../Sections/StudentNotification/Content";
const StudentNotification = () => {
  return <StudentNotificationSection />;
};

export default StudentNotification;
